(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-testimonial-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var slidesEl = carousel.querySelector('[data-slides]');
    var slideEls = Array.prototype.slice.call(carousel.querySelectorAll('[data-slide]'));
    var total = slideEls.length;
    var current = 0;

    // Sync play-btn UI from video events (works for both autoplay and manual)
    function bindVideoUI(slideEl) {
      var video = slideEl.querySelector('[data-video-el]');
      var btn   = slideEl.querySelector('[data-play-btn]');
      if (!video || !btn) return;
      var pi = btn.querySelector('[data-play-icon]');
      var pa = btn.querySelector('[data-pause-icon]');

      video.addEventListener('play', function () {
        btn.classList.add('is-playing');
        if (pi) pi.style.display = 'none';
        if (pa) pa.style.display = '';
      });
      video.addEventListener('pause', function () {
        btn.classList.remove('is-playing');
        if (pi) pi.style.display = '';
        if (pa) pa.style.display = 'none';
      });

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) { video.play(); } else { video.pause(); }
      });
    }

    slideEls.forEach(function (sl) { bindVideoUI(sl); });

    function playSlideVideo(idx) {
      var video = slideEls[idx].querySelector('[data-video-el]');
      if (video) { video.play().catch(function(){}); }
    }

    function pauseSlideVideo(idx) {
      var video = slideEls[idx].querySelector('[data-video-el]');
      if (video) { video.pause(); }
    }

    // Only needed when multiple slides exist
    if (total <= 1) {
      playSlideVideo(0);
      return;
    }

    function goTo(idx) {
      pauseSlideVideo(current);
      current = (idx + total) % total;
      slidesEl.style.transform = 'translateX(-' + (current * 100) + '%)';
      carousel.querySelectorAll('[data-dot]').forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.dot) === current);
      });
      playSlideVideo(current);
    }

    // Event delegation for arrows + dots
    carousel.addEventListener('click', function (e) {
      if (e.target.closest('[data-play-btn]')) return; // handled above
      var p = e.target.closest('[data-prev]');
      var n = e.target.closest('[data-next]');
      var d = e.target.closest('[data-dot]');
      if (p) goTo(current - 1);
      if (n) goTo(current + 1);
      if (d) goTo(parseInt(d.dataset.dot));
    });

    // Swipe support
    var startX = 0;
    var dragging = false;
    slidesEl.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; dragging = true; }, { passive: true });
    slidesEl.addEventListener('touchend', function (e) {
      if (!dragging) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
      dragging = false;
    });
    slidesEl.addEventListener('mousedown', function (e) { startX = e.clientX; dragging = true; });
    slidesEl.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 60) goTo(current + (dx < 0 ? 1 : -1));
      dragging = false;
    });

    // Try to play first slide (backup in case HTML autoplay didn't fire)
    playSlideVideo(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-floating-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── helpers ── */
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function wrap(i, len) {
    return ((i % len) + len) % len;
  }

  function img(v, lazy) {
    if (!v || !v.img) return '';
    var loading = lazy ? ' loading="lazy"' : ' loading="eager"';
    return '<img src="' + v.img +
           '" srcset="' + v.img + ' 1x,' + (v.img2x || v.img) + ' 2x"' +
           ' alt="' + esc(v.imgAlt) + '"' +
           loading + ' decoding="async">';
  }

  /* ── main carousel class ── */
  function VFC(root) {
    var sid   = root.dataset.sectionId;
    var dataEl = document.getElementById('vfc-data-' + sid);
    if (!dataEl) return;

    var data, variants, cfg;
    try { data = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    variants = data.variants;
    cfg      = data.cfg;

    if (!variants || !variants.length) return;

    var count   = variants.length;
    var idx     = 0;       /* active variant index */
    var busy    = false;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* DOM */
    var car       = root.querySelector('[data-vfc-car="'         + sid + '"]');
    var slotPrev  = root.querySelector('[data-vfc-prev-slot="'   + sid + '"]');
    var slotCtr   = root.querySelector('[data-vfc-center-slot="' + sid + '"]');
    var floatEl   = root.querySelector('[data-vfc-float="'       + sid + '"]');
    var slotNext  = root.querySelector('[data-vfc-next-slot="'   + sid + '"]');
    var subEl     = root.querySelector('[data-vfc-sub="'         + sid + '"]');
    var priceEl   = root.querySelector('[data-vfc-price="'       + sid + '"]');
    var compareEl = root.querySelector('[data-vfc-compare="'     + sid + '"]');
    var ctaEl     = root.querySelector('[data-vfc-cta="'         + sid + '"]');
    var dotsEl    = root.querySelector('[data-vfc-dots="'        + sid + '"]');
    var prevBtn   = root.querySelector('[data-vfc-prev="'        + sid + '"]');
    var nextBtn   = root.querySelector('[data-vfc-next="'        + sid + '"]');

    /* ── render ── */
    function fillSlots() {
      var pi = wrap(idx - 1, count);
      var ni = wrap(idx + 1, count);
      if (slotPrev) slotPrev.innerHTML = img(variants[pi],  true);
      if (floatEl)  floatEl.innerHTML  = img(variants[idx], false);
      if (slotNext) slotNext.innerHTML = img(variants[ni],  true);
    }

    function updateMeta() {
      var v = variants[idx];

      if (subEl) subEl.textContent = v.customSub || v.title;

      if (priceEl) priceEl.textContent = v.price;

      if (compareEl) {
        if (cfg.showCompare && v.compareAt) {
          compareEl.textContent = v.compareAt;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (ctaEl) {
        ctaEl.dataset.vid  = v.id;
        ctaEl.dataset.vurl = v.variantUrl;
        ctaEl.textContent  = v.customCta || cfg.ctaText;
      }

      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.vfc-dot');
        dots.forEach(function (d, i) {
          var on = (i === idx);
          d.classList.toggle('vfc-dot--on', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
    }

    function goTo(newIdx, animate) {
      if (busy) return;
      busy = true;
      idx = wrap(newIdx, count);

      var delay = (animate && !reduced && car) ? 200 : 0;
      if (delay && car) car.classList.add('vfc-t');

      setTimeout(function () {
        fillSlots();
        updateMeta();
        if (car) car.classList.remove('vfc-t');
        busy = false;
      }, delay);
    }

    /* ── CTA action ── */
    function handleCta() {
      var action = cfg.ctaAction;
      var vid    = ctaEl.dataset.vid;
      var vurl   = ctaEl.dataset.vurl;

      if (action === 'add_to_cart') {
        var label = ctaEl.textContent;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          ctaEl.textContent = 'Added ✓';
          setTimeout(function () { ctaEl.textContent = label; }, 1800);
        })
        .catch(function () { window.location.href = vurl; });

      } else if (action === 'scroll_to_form') {
        var form = document.querySelector('[action*="/cart/add"]');
        if (form) {
          var sel = form.querySelector('[name="id"]');
          if (sel) {
            sel.value = vid;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          window.location.href = vurl;
        }

      } else {
        window.location.href = vurl;
      }
    }

    /* ── Events ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(idx + 1, true); });

    if (slotPrev) slotPrev.addEventListener('click', function () { goTo(idx - 1, true); });
    if (slotNext) slotNext.addEventListener('click', function () { goTo(idx + 1, true); });

    if (dotsEl) {
      dotsEl.querySelectorAll('.vfc-dot').forEach(function (d) {
        d.addEventListener('click', function () {
          goTo(parseInt(d.dataset.di, 10), true);
        });
      });
    }

    if (ctaEl) ctaEl.addEventListener('click', handleCta);

    /* Keyboard */
    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(idx - 1, true); e.preventDefault(); }
      if (e.key === 'ArrowRight') { goTo(idx + 1, true); e.preventDefault(); }
    });

    /* Touch swipe */
    var tx = 0;
    if (car) {
      car.addEventListener('touchstart', function (e) {
        tx = e.touches[0].clientX;
      }, { passive: true });
      car.addEventListener('touchend', function (e) {
        var dx = tx - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 44) goTo(dx > 0 ? idx + 1 : idx - 1, true);
      }, { passive: true });
    }

    /* Float + reduced motion */
    if (!cfg.floatOn || reduced) root.classList.add('vfc-no-float');

    /* Boot */
    goTo(0, false);
  }

  /* ── Init all instances ── */
  function initAll() {
    document.querySelectorAll('.vfc-section[data-section-id]').forEach(function (el) {
      if (!el._vfcDone) { el._vfcDone = true; try { VFC(el); } catch (e) {} }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.vfc-section');
    if (el && !el._vfcDone) { el._vfcDone = true; try { VFC(el); } catch (e) {} }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyrrox-feature-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function VFC(root) {
    if (!root) return;

    var sid      = root.dataset.sid;
    var autoplay = root.dataset.autoplay === 'true';
    var speed    = parseInt(root.dataset.speed, 10) || 4000;

    var track  = document.getElementById('vfc-tr-'   + sid);
    var dotsEl = document.getElementById('vfc-dots-' + sid);
    var prev   = root.querySelector('.vfc__btn--prev');
    var next   = root.querySelector('.vfc__btn--next');

    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.vfc__card'));
    var total = cards.length;
    var cur   = 0;
    var timer = null;

    function isMobile() { return window.innerWidth < 769; }

    function step() {
      if (!cards[0]) return 1;
      return cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    }

    function clamp(n) { return Math.max(0, Math.min(total - 1, n)); }

    function go(idx) {
      cur = clamp(idx);
      track.scrollTo({ left: cur * step(), behavior: 'smooth' });
      sync();
    }

    function sync() {
      if (dotsEl) {
        dotsEl.querySelectorAll('.vfc__dot').forEach(function (d, i) {
          var on = i === cur;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      if (prev) prev.disabled = cur <= 0;
      if (next) next.disabled = cur >= total - 1;
    }

    function startTimer() {
      if (!autoplay || !isMobile()) return;
      stopTimer();
      timer = setInterval(function () { go(cur < total - 1 ? cur + 1 : 0); }, speed);
    }
    function stopTimer() { clearInterval(timer); timer = null; }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (!isMobile()) return;
        var s = step();
        if (!s) return;
        var idx = Math.round(track.scrollLeft / s);
        if (idx !== cur) { cur = clamp(idx); sync(); }
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { stopTimer(); go(cur - 1); startTimer(); });
    if (next) next.addEventListener('click', function () { stopTimer(); go(cur + 1); startTimer(); });

    if (dotsEl) {
      dotsEl.addEventListener('click', function (e) {
        var d = e.target.closest('.vfc__dot');
        if (d) { stopTimer(); go(parseInt(d.dataset.i, 10)); startTimer(); }
      });
    }

    track.addEventListener('touchstart', stopTimer, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(startTimer, 700); }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (!isMobile()) return;
      if (e.key === 'ArrowLeft')  { stopTimer(); go(cur - 1); startTimer(); }
      if (e.key === 'ArrowRight') { stopTimer(); go(cur + 1); startTimer(); }
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        isMobile() ? startTimer() : stopTimer();
        sync();
      }, 200);
    });

    sync();
    if (autoplay) setTimeout(startTimer, 1200);
  }

  function run() { document.querySelectorAll('[data-vfc]').forEach(VFC); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run)
    : run();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-vfc]');
    if (el) VFC(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyrrox-feature-cardsd"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function VFC(root) {
    if (!root) return;

    var sid      = root.dataset.sid;
    var autoplay = root.dataset.autoplay === 'true';
    var speed    = parseInt(root.dataset.speed, 10) || 4000;

    var track  = document.getElementById('vfc-tr-'   + sid);
    var dotsEl = document.getElementById('vfc-dots-' + sid);
    var prev   = root.querySelector('.vfc__btn--prev');
    var next   = root.querySelector('.vfc__btn--next');

    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.vfc__card'));
    var total = cards.length;
    var cur   = 0;
    var timer = null;

    function isMobile() { return window.innerWidth < 769; }

    function step() {
      if (!cards[0]) return 1;
      return cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    }

    function clamp(n) { return Math.max(0, Math.min(total - 1, n)); }

    function go(idx) {
      cur = clamp(idx);
      track.scrollTo({ left: cur * step(), behavior: 'smooth' });
      sync();
    }

    function sync() {
      if (dotsEl) {
        dotsEl.querySelectorAll('.vfc__dot').forEach(function (d, i) {
          var on = i === cur;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      if (prev) prev.disabled = cur <= 0;
      if (next) next.disabled = cur >= total - 1;
    }

    function startTimer() {
      if (!autoplay || !isMobile()) return;
      stopTimer();
      timer = setInterval(function () { go(cur < total - 1 ? cur + 1 : 0); }, speed);
    }
    function stopTimer() { clearInterval(timer); timer = null; }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (!isMobile()) return;
        var s = step();
        if (!s) return;
        var idx = Math.round(track.scrollLeft / s);
        if (idx !== cur) { cur = clamp(idx); sync(); }
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { stopTimer(); go(cur - 1); startTimer(); });
    if (next) next.addEventListener('click', function () { stopTimer(); go(cur + 1); startTimer(); });

    if (dotsEl) {
      dotsEl.addEventListener('click', function (e) {
        var d = e.target.closest('.vfc__dot');
        if (d) { stopTimer(); go(parseInt(d.dataset.i, 10)); startTimer(); }
      });
    }

    track.addEventListener('touchstart', stopTimer, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(startTimer, 700); }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (!isMobile()) return;
      if (e.key === 'ArrowLeft')  { stopTimer(); go(cur - 1); startTimer(); }
      if (e.key === 'ArrowRight') { stopTimer(); go(cur + 1); startTimer(); }
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        isMobile() ? startTimer() : stopTimer();
        sync();
      }, 200);
    });

    sync();
    if (autoplay) setTimeout(startTimer, 1200);
  }

  function run() { document.querySelectorAll('[data-vfc]').forEach(VFC); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run)
    : run();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-vfc]');
    if (el) VFC(el);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
